import { brand } from "@mbb/config";

type Props = {
  size?: number;
  monochrome?: boolean;
  className?: string;
};

/** A vintage hotel-style crest: arched shield, central book, year banner. */
export default function Crest({ size = 88, monochrome = false, className }: Props) {
  const fillCoral = monochrome ? "currentColor" : "var(--c-coral)";
  const fillPalm = monochrome ? "currentColor" : "var(--c-palm)";
  const fillBlush = monochrome ? "currentColor" : "var(--c-blush)";
  const fillBrass = monochrome ? "currentColor" : "var(--c-brass)";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      role="img"
      aria-label={`${brand.shortName} crest`}
      className={className}
    >
      {/* shield */}
      <path
        d="M60 6 C82 6 100 14 100 14 L100 60 C100 90 80 108 60 114 C40 108 20 90 20 60 L20 14 C20 14 38 6 60 6 Z"
        fill={fillBlush}
        stroke={fillPalm}
        strokeWidth="2"
      />
      {/* inner arch */}
      <path
        d="M34 36 C34 24 46 18 60 18 C74 18 86 24 86 36 L86 74 L34 74 Z"
        fill={fillCoral}
        opacity="0.95"
      />
      {/* book */}
      <g transform="translate(60 52)">
        <rect x="-18" y="-12" width="36" height="22" rx="2" fill={fillBlush} />
        <line x1="0" y1="-12" x2="0" y2="10" stroke={fillPalm} strokeWidth="1.6" />
        <line x1="-12" y1="-4" x2="-4" y2="-4" stroke={fillPalm} strokeWidth="1.2" />
        <line x1="4" y1="-4" x2="12" y2="-4" stroke={fillPalm} strokeWidth="1.2" />
        <line x1="-12" y1="2" x2="-4" y2="2" stroke={fillPalm} strokeWidth="1.2" />
        <line x1="4" y1="2" x2="12" y2="2" stroke={fillPalm} strokeWidth="1.2" />
      </g>
      {/* banner */}
      <path
        d="M18 84 L102 84 L94 100 L26 100 Z"
        fill={fillBrass}
        stroke={fillPalm}
        strokeWidth="1.5"
      />
      <text
        x="60"
        y="96"
        textAnchor="middle"
        fontFamily="Archivo, system-ui, sans-serif"
        fontWeight="700"
        fontSize="8.5"
        letterSpacing="0.25em"
        fill={fillPalm}
      >
        EST {brand.established}
      </text>
    </svg>
  );
}
